export default __webpack_public_path__ + "static/media/main_6.8e151bce.jpeg";